export default __webpack_public_path__ + "e36c718b87c2b30cc45bbfe1273e6ba0.png";